import { GET_ERRORS, SET_CURRENT_USER, USER_LOADING } from './types';
import { getErrorMessage } from '../utils/util.errors';
import setAuthToken from '../utils/setAuthToken';
import services from '../config/services';
import jwt_decode from 'jwt-decode';
import axios from 'axios';

const URL_LOGIN = process.env.REACT_APP_API_URL + services.login;

export const loginUser = userData => dispatch => {
	axios.post(URL_LOGIN, userData)
		.then(res => {
			const { token, user } = res.data.result;
			if (user && !user.roles.includes('CMS')) {
				dispatch({
					type: GET_ERRORS,
					payload: 'Su usuario no cuenta con las permisos para acceder al CMS.'
				})
			} else {
				localStorage.setItem('jwtTokenFarmazon', JSON.stringify(token));
				localStorage.setItem('user_id',          user._id);
				setAuthToken(token);
				const decoded = jwt_decode(token);
				dispatch(setCurrentUser(decoded));
			}
		})
		.catch(err => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(err)
			})
		});
};

export const setCurrentUser = decoded => {
	return {
		type: SET_CURRENT_USER,
		payload: decoded
	};
};

export const setUserLoading = () => {
	return {
		type: USER_LOADING
	};
};

export const logoutUser = history => dispatch => {
	localStorage.removeItem('jwtTokenFarmazon');
	setAuthToken(false);
	dispatch(setCurrentUser({}));
	if (history) {
		history.push('/dashboard');
	}
};
